
export const formatDate = (dateString: string | Date | null): string => {
  if (!dateString) return 'Unknown date';
  
  try {
    const date = typeof dateString === 'string' ? new Date(dateString) : dateString;
    
    // Format the date as "Month Day, Year"
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'Invalid date';
  }
};

// Convert a Date object to ISO string format for database storage
export const dateToISOString = (date: Date | null): string | null => {
  if (!date) return null;
  return date.toISOString();
};

// Convert a Date object to YYYY-MM-DD format for database storage
export const dateToYYYYMMDD = (date: Date | null): string | null => {
  if (!date) return null;
  return date.toISOString().split('T')[0];
};

// Convert a string or Date to string for the database
export const dateToString = (date: Date | string | null): string | null => {
  if (!date) return null;
  if (date instanceof Date) {
    return dateToYYYYMMDD(date);
  }
  return date;
};
